import Layout1 from './1/Layout'
import Layout2 from './2/Layout'
import Layout3 from './3/Layout'

const LayoutSelector = (props) => {
    let chosenLayout = (
        <Layout1 fields={props.fields} contactFields={props.contactFields} />
    )
    if (props.layout === 2) {
        chosenLayout = (
            <Layout2
                fields={props.fields}
                contactFields={props.contactFields}
            />
        )
    }
    if (props.layout === 3) {
        chosenLayout = (
            <Layout3
                fields={props.fields}
                contactFields={props.contactFields}
            />
        )
    }

    return chosenLayout
}

export default LayoutSelector
